/* Offer-page countdown. The existing header keeps the same bar sticky. */
(() => {
  const bar = document.querySelector('[data-ds-animal-end]');
  if (!bar || bar.dataset.countdownReady) return;
  const end = Date.parse(bar.dataset.dsAnimalEnd);
  if (!Number.isFinite(end)) return;
  const numbers = bar.querySelectorAll('.animal-number');
  if (numbers.length !== 4) return;
  bar.dataset.countdownReady = 'true';
  let timer;
  const tick = () => {
    const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
    const parts = [Math.floor(remaining / 86400), Math.floor(remaining / 3600) % 24, Math.floor(remaining / 60) % 60, remaining % 60];
    parts.forEach((value, index) => { numbers[index].textContent = String(value).padStart(2, '0'); });
    if (!remaining) { bar.hidden = true; clearInterval(timer); }
  };
  timer = setInterval(tick, 1000);
  tick();
  addEventListener('pageshow', tick);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
})();
